import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { RunOnceScheduler, runWhenGlobalIdle } from 'monaco-editor/esm/vs/base/common/async.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import { Disposable, toDisposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { createDecorator, IInstantiationService } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { userActivityRegistry } from './userActivityRegistry.js';
const IUserActivityService = ( createDecorator('IUserActivityService'));
let UserActivityService = class UserActivityService extends Disposable {
    constructor(instantiationService) {
        super();
        this.markInactive = this._register(( new RunOnceScheduler(() => {
            this.isActive = false;
            this.changeEmitter.fire(false);
        }, 10000)));
        this.changeEmitter = this._register(( new Emitter()));
        this.active = 0;
        this.isActive = true;
        this.onDidChangeIsActive = this.changeEmitter.event;
        this._register(runWhenGlobalIdle(() => userActivityRegistry.take(this, instantiationService)));
    }
    markActive() {
        if (++this.active === 1) {
            this.isActive = true;
            this.changeEmitter.fire(true);
            this.markInactive.cancel();
        }
        return toDisposable(() => {
            if (--this.active === 0) {
                this.markInactive.schedule();
            }
        });
    }
};
UserActivityService = ( __decorate([
    ( __param(0, IInstantiationService))
], UserActivityService));
export { IUserActivityService, UserActivityService };
